import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CertificationService } from '../services/certification.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AppSettings } from '../../shared/configuration/appsettings.config';
import { attachment } from '../models/attachment';
import { taxReviewModel } from '../models/taxFormModel';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';


interface Countries {
  name: string;
  value: string;
}

@Component({
    selector: 'app-review-certification',
    templateUrl: './review-certification.component.html'
})
export class ReviewCertificationComponent implements OnInit {

    broker: any;
    identity: any;
    contact: any;
    shareOwnership: any;
    declarations: any;
    beneficialOwner: any;
    fileAttachments: attachment[];
    enableOwnerForm: boolean;
    taxReview: UntypedFormGroup;
    errorCollection: any[];
    selectedcountryOfResidence: string;
    selectedcountryOfIncorporation: string;
    selectedPrCntfResidence: string;
    selectedMailingCnt: string;
    selectedCountriesOfCitizenship: string;
    showAppendixA: boolean = false;
    showConfirmation: boolean = false;
    showW8W9ReplaceConfirmation: boolean = false;
    shareWorthLess300k: string;
    shareWorthMore500k: string;
    private countryList: Countries[] = [

        { value: "AFG", name: "Afghanistan" },
        { value: "ALA", name: "Åland Islands" },
        { value: "ALB", name: "Albania" },
        { value: "DZA", name: "Algeria" },
        { value: "ASM", name: "American Samoa" },
        { value: "AND", name: "Andorra" },
        { value: "AGO", name: "Angola" },
        { value: "AIA", name: "Anguilla" },
        { value: "ATA", name: "Antarctica" },
        { value: "ATG", name: "Antigua and Barbuda" },
        { value: "ARG", name: "Argentina" },
        { value: "ARM", name: "Armenia" },
        { value: "ABW", name: "Aruba" },
        { value: "AUS", name: "Australia" },
        { value: "AUT", name: "Austria" },
        { value: "AZE", name: "Azerbaijan" },
        { value: "BHS", name: "Bahamas (the)" },
        { value: "BHR", name: "Bahrain" },
        { value: "BGD", name: "Bangladesh" },
        { value: "BRB", name: "Barbados" },
        { value: "BLR", name: "Belarus" },
        { value: "BEL", name: "Belgium" },
        { value: "BLZ", name: "Belize" },
        { value: "BEN", name: "Benin" },
        { value: "BMU", name: "Bermuda" },
        { value: "BTN", name: "Bhutan" },
        { value: "BOL", name: "Bolivia (Plurinational State of)" },
        { value: "BES", name: "Bonaire, Sint Eustatius and Saba" },
        { value: "BIH", name: "Bosnia and Herzegovina" },
        { value: "BWA", name: "Botswana" },
        { value: "BVT", name: "Bouvet Island" },
        { value: "BRA", name: "Brazil" },
        { value: "IOT", name: "British Indian Ocean Territory (the)" },
        { value: "BRN", name: "Brunei Darussalam" },
        { value: "BGR", name: "Bulgaria" },
        { value: "BFA", name: "Burkina Faso" },
        { value: "BDI", name: "Burundi" },
        { value: "CPV", name: "Cabo Verde" },
        { value: "KHM", name: "Cambodia" },
        { value: "CMR", name: "Cameroon" },
        { value: "CAN", name: "Canada" },
        { value: "CYM", name: "Cayman Islands (the)" },
        { value: "CAF", name: "Central African Republic (the)" },
        { value: "TCD", name: "Chad" },
        { value: "CHL", name: "Chile" },
        { value: "CHN", name: "China" },
        { value: "CXR", name: "Christmas Island" },
        { value: "CCK", name: "Cocos (Keeling) Islands (the)" },
        { value: "COL", name: "Colombia" },
        { value: "COM", name: "Comoros (the)" },
        { value: "COD", name: "Congo (the Democratic Republic of the)" },
        { value: "COG", name: "Congo (the)" },
        { value: "COK", name: "Cook Islands (the)" },
        { value: "CRI", name: "Costa Rica" },
        { value: "CIV", name: "Côte d'Ivoire" },
        { value: "HRV", name: "Croatia" },
        { value: "CUB", name: "Cuba" },
        { value: "CUW", name: "Curaçao" },
        { value: "CYP", name: "Cyprus" },
        { value: "CZE", name: "Czechia" },
        { value: "DNK", name: "Denmark" },
        { value: "DJI", name: "Djibouti" },
        { value: "DMA", name: "Dominica" },
        { value: "DOM", name: "Dominican Republic (the)" },
        { value: "ECU", name: "Ecuador" },
        { value: "EGY", name: "Egypt" },
        { value: "SLV", name: "El Salvador" },
        { value: "GNQ", name: "Equatorial Guinea" },
        { value: "ERI", name: "Eritrea" },
        { value: "EST", name: "Estonia" },
        { value: "SWZ", name: "Eswatini" },
        { value: "ETH", name: "Ethiopia" },
        { value: "FLK", name: "Falkland Islands (the) [Malvinas]" },
        { value: "FRO", name: "Faroe Islands (the)" },
        { value: "FJI", name: "Fiji" },
        { value: "FIN", name: "Finland" },
        { value: "FRA", name: "France" },
        { value: "GUF", name: "French Guiana" },
        { value: "PYF", name: "French Polynesia" },
        { value: "ATF", name: "French Southern Territories (the)" },
        { value: "GAB", name: "Gabon" },
        { value: "GMB", name: "Gambia (the)" },
        { value: "GEO", name: "Georgia" },
        { value: "DEU", name: "Germany" },
        { value: "GHA", name: "Ghana" },
        { value: "GIB", name: "Gibraltar" },
        { value: "GRC", name: "Greece" },
        { value: "GRL", name: "Greenland" },
        { value: "GRD", name: "Grenada" },
        { value: "GLP", name: "Guadeloupe" },
        { value: "GUM", name: "Guam" },
        { value: "GTM", name: "Guatemala" },
        { value: "GGY", name: "Guernsey" },
        { value: "GIN", name: "Guinea" },
        { value: "GNB", name: "Guinea-Bissau" },
        { value: "GUY", name: "Guyana" },
        { value: "HTI", name: "Haiti" },
        { value: "HMD", name: "Heard Island and McDonald Islands" },
        { value: "VAT", name: "Holy See (the)" },
        { value: "HND", name: "Honduras" },
        { value: "HKG", name: "Hong Kong" },
        { value: "HUN", name: "Hungary" },
        { value: "ISL", name: "Iceland" },
        { value: "IND", name: "India" },
        { value: "IDN", name: "Indonesia" },
        { value: "IRN", name: "Iran (Islamic Republic of)" },
        { value: "IRQ", name: "Iraq" },
        { value: "IRL", name: "Ireland" },
        { value: "IMN", name: "Isle of Man" },
        { value: "ISR", name: "Israel" },
        { value: "ITA", name: "Italy" },
        { value: "JAM", name: "Jamaica" },
        { value: "JPN", name: "Japan" },
        { value: "JEY", name: "Jersey" },
        { value: "JOR", name: "Jordan" },
        { value: "KAZ", name: "Kazakhstan" },
        { value: "KEN", name: "Kenya" },
        { value: "KIR", name: "Kiribati" },
        { value: "PRK", name: "Korea (the Democratic People's Republic of)" },
        { value: "KOR", name: "Korea (the Republic of)" },
        { value: "KWT", name: "Kuwait" },
        { value: "KGZ", name: "Kyrgyzstan" },
        { value: "LAO", name: "Lao People's Democratic Republic (the)" },
        { value: "LVA", name: "Latvia" },
        { value: "LBN", name: "Lebanon" },
        { value: "LSO", name: "Lesotho" },
        { value: "LBR", name: "Liberia" },
        { value: "LBY", name: "Libya" },
        { value: "LIE", name: "Liechtenstein" },
        { value: "LTU", name: "Lithuania" },
        { value: "LUX", name: "Luxembourg" },
        { value: "MAC", name: "Macao" },
        { value: "MKD", name: "Macedonia (the former Yugoslav Republic of)" },
        { value: "MDG", name: "Madagascar" },
        { value: "MWI", name: "Malawi" },
        { value: "MYS", name: "Malaysia" },
        { value: "MDV", name: "Maldives" },
        { value: "MLI", name: "Mali" },
        { value: "MLT", name: "Malta" },
        { value: "MHL", name: "Marshall Islands (the)" },
        { value: "MTQ", name: "Martinique" },
        { value: "MRT", name: "Mauritania" },
        { value: "MUS", name: "Mauritius" },
        { value: "MYT", name: "Mayotte" },
        { value: "MEX", name: "Mexico" },
        { value: "FSM", name: "Micronesia (Federated States of)" },
        { value: "MDA", name: "Moldova (the Republic of)" },
        { value: "MCO", name: "Monaco" },
        { value: "MNG", name: "Mongolia" },
        { value: "MNE", name: "Montenegro" },
        { value: "MSR", name: "Montserrat" },
        { value: "MAR", name: "Morocco" },
        { value: "MOZ", name: "Mozambique" },
        { value: "MMR", name: "Myanmar" },
        { value: "NAM", name: "Namibia" },
        { value: "NRU", name: "Nauru" },
        { value: "NPL", name: "Nepal" },
        { value: "NLD", name: "Netherlands (the)" },
        { value: "NCL", name: "New Caledonia" },
        { value: "NZL", name: "New Zealand" },
        { value: "NIC", name: "Nicaragua" },
        { value: "NER", name: "Niger (the)" },
        { value: "NGA", name: "Nigeria" },
        { value: "NIU", name: "Niue" },
        { value: "NFK", name: "Norfolk Island" },
        { value: "MNP", name: "Northern Mariana Islands (the)" },
        { value: "NOR", name: "Norway" },
        { value: "OMN", name: "Oman" },
        { value: "PAK", name: "Pakistan" },
        { value: "PLW", name: "Palau" },
        { value: "PSE", name: "Palestine, State of" },
        { value: "PAN", name: "Panama" },
        { value: "PNG", name: "Papua New Guinea" },
        { value: "PRY", name: "Paraguay" },
        { value: "PER", name: "Peru" },
        { value: "PHL", name: "Philippines (the)" },
        { value: "PCN", name: "Pitcairn" },
        { value: "POL", name: "Poland" },
        { value: "PRT", name: "Portugal" },
        { value: "PRI", name: "Puerto Rico" },
        { value: "QAT", name: "Qatar" },
        { value: "REU", name: "Réunion" },
        { value: "ROU", name: "Romania" },
        { value: "RUS", name: "Russian Federation (the)" },
        { value: "RWA", name: "Rwanda" },
        { value: "BLM", name: "Saint Barthélemy" },
        { value: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" },
        { value: "KNA", name: "Saint Kitts and Nevis" },
        { value: "LCA", name: "Saint Lucia" },
        { value: "MAF", name: "Saint Martin (French part)" },
        { value: "SPM", name: "Saint Pierre and Miquelon" },
        { value: "VCT", name: "Saint Vincent and the Grenadines" },
        { value: "WSM", name: "Samoa" },
        { value: "SMR", name: "San Marino" },
        { value: "STP", name: "Sao Tome and Principe" },
        { value: "SAU", name: "Saudi Arabia" },
        { value: "SEN", name: "Senegal" },
        { value: "SRB", name: "Serbia" },
        { value: "SYC", name: "Seychelles" },
        { value: "SLE", name: "Sierra Leone" },
        { value: "SGP", name: "Singapore" },
        { value: "SXM", name: "Sint Maarten (Dutch part)" },
        { value: "SVK", name: "Slovakia" },
        { value: "SVN", name: "Slovenia" },
        { value: "SLB", name: "Solomon Islands" },
        { value: "SOM", name: "Somalia" },
        { value: "ZAF", name: "South Africa" },
        { value: "SGS", name: "South Georgia and the South Sandwich Islands" },
        { value: "SSD", name: "South Sudan" },
        { value: "ESP", name: "Spain" },
        { value: "LKA", name: "Sri Lanka" },
        { value: "SDN", name: "Sudan (the)" },
        { value: "SUR", name: "Suriname" },
        { value: "SJM", name: "Svalbard and Jan Mayen" },
        { value: "SWE", name: "Sweden" },
        { value: "CHE", name: "Switzerland" },
        { value: "SYR", name: "Syrian Arab Republic" },
        { value: "TWN", name: "Taiwan (Province of China)" },
        { value: "TJK", name: "Tajikistan" },
        { value: "TZA", name: "Tanzania, United Republic of" },
        { value: "THA", name: "Thailand" },
        { value: "TLS", name: "Timor-Leste" },
        { value: "TGO", name: "Togo" },
        { value: "TKL", name: "Tokelau" },
        { value: "TON", name: "Tonga" },
        { value: "TTO", name: "Trinidad and Tobago" },
        { value: "TUN", name: "Tunisia" },
        { value: "TUR", name: "Turkey" },
        { value: "TKM", name: "Turkmenistan" },
        { value: "TCA", name: "Turks and Caicos Islands (the)" },
        { value: "TUV", name: "Tuvalu" },
        { value: "UGA", name: "Uganda" },
        { value: "UKR", name: "Ukraine" },
        { value: "ARE", name: "United Arab Emirates (the)" },
        { value: "GBR", name: "United Kingdom of Great Britain and Northern Ireland (the)" },
        { value: "UMI", name: "United States Minor Outlying Islands (the)" },
        { value: "USA", name: "United States of America (the)" },
        { value: "URY", name: "Uruguay" },
        { value: "UZB", name: "Uzbekistan" },
        { value: "VUT", name: "Vanuatu" },
        { value: "VEN", name: "Venezuela (Bolivarian Republic of)" },
        { value: "VNM", name: "Viet Nam" },
        { value: "VGB", name: "Virgin Islands (British)" },
        { value: "VIR", name: "Virgin Islands (U.S.)" },
        { value: "WLF", name: "Wallis and Futuna" },
        { value: "ESH", name: "Western Sahara*" },
        { value: "YEM", name: "Yemen" },
        { value: "ZMB", name: "Zambia" },
        { value: "ZWE", name: "Zimbabwe" }
    ];
    sharesOfCompany: string;
    israeliCitizenYesNo: string;

    constructor(private certificationService: CertificationService, public router: Router, private route: ActivatedRoute, private fb: UntypedFormBuilder, private title: Title) {

        this.title.setTitle('Review Your Application Details')
    }

    ngOnInit() {

        this.initForm();
        let reviewData: any = this.route.snapshot.data['data'];
        this.loadInitData(reviewData.certificationObject, reviewData.taxFormConents);
    }

    get taxReviewControls() {
        return this.taxReview.controls;
    }

    private initForm() {
        this.taxReview = this.fb.group({
            'hasAgree': new UntypedFormControl(null),
            'agreeMetadata': new UntypedFormControl(null),

            'hasSahreOwner': new UntypedFormControl(null),
            'hasLessThan300k': new UntypedFormControl(null),
            'hasLessThan500k': new UntypedFormControl(null),
            'notRelative': new UntypedFormControl(null),
            'notE2': new UntypedFormControl(null),
            'isIndividual': new UntypedFormControl(null),
            'iscooperation': new UntypedFormControl(null),
            'ispartnerships': new UntypedFormControl(null),
            'istrust': new UntypedFormControl(null),
            'declaration': new UntypedFormControl(null),
            'certification': new UntypedFormControl(null),
            'taxDeclarationCompleted': new UntypedFormControl(null),
            'noChangeofOwnership': new UntypedFormControl(null),
            'beneficialOwnerCertification': new UntypedFormControl(null)
        });
    }

    private loadInitData(data: any, reviewFormContent: any) {
        if (data != null) {

            this.broker = data.brokerDetails;
            this.identity = data.identity;
            this.contact = data.contact;
            this.shareOwnership = data.shareOwnership;
            this.shareWorthLess300k = data.shareOwnership.shareWorthLess300k;
            this.shareWorthMore500k = data.shareOwnership.shareWorthMore500k;
            this.declarations = data.declarations;
            this.beneficialOwner = data.beneficialOwnerDeclaration;
            this.enableOwnerForm = reviewFormContent.enableOwnerForm;
            this.fileAttachments = data.fileAttachments;

            if (data.shareOwnership.holdingType == "1") {
                this.sharesOfCompany = "Directly, as a Registered Shareholder";
            }
            else if (data.shareOwnership.holdingType == "2") {
                this.sharesOfCompany = "Through a Broker/Financial Advisor/Custodian";
            }
            else if (data.shareOwnership.holdingType == "3") {
                this.sharesOfCompany = "I am a bank, broker or financial institution that is a \"resident of Israel\"";
            }

            if (this.identity.residencyCountry != "")
                this.selectedcountryOfResidence = this.getCountryNameByCode(this.identity.residencyCountry);
            if (this.identity.corporationCountry != "")
                this.selectedcountryOfIncorporation = this.getCountryNameByCode(this.identity.corporationCountry);
            if (this.contact.streetCountry != "")
                this.selectedPrCntfResidence = this.getCountryNameByCode(this.contact.streetCountry);
            if (this.contact.mailingCountry != "")
                this.selectedMailingCnt = this.getCountryNameByCode(this.contact.mailingCountry);
            if (this.identity.citizenshipCountries != "")
                this.setCountryOfCitizenshipSelected(this.identity.citizenshipCountries);


            debugger;
            if (this.identity.israeliCitizen == "1") {
                this.israeliCitizenYesNo = "Yes";
            }
            if (this.identity.israeliCitizen == "0") {
                this.israeliCitizenYesNo = "No";
            }
            //console.log(this.selectedcountryOfResidence);
        }
    }



    setCountryOfCitizenshipSelected(listOfCountries: string) {

        var citizenshipCountries = listOfCountries.split(',');
        this.selectedCountriesOfCitizenship = this.countryList.filter(a => (citizenshipCountries.indexOf(a.value) != -1)).map((e: any) => e.name).join(", ");
    }

    getCountryNameByCode(countryCode) {
        return this.countryList.filter(obj => obj.value == countryCode)[0].name;
    }

    submitTaxReview() {

        this.clearUIErrors();

        let taxReviewModel: taxReviewModel = {
            hasSahreOwner: this.taxReviewControls['hasSahreOwner'].value == null ? false : this.taxReviewControls['hasSahreOwner'].value,
            hasLessThan300k: this.taxReviewControls['hasLessThan300k'].value == null ? false : this.taxReviewControls['hasLessThan300k'].value,
            hasLessThan500k: this.taxReviewControls['hasLessThan500k'].value == null ? false : this.taxReviewControls['hasLessThan500k'].value,
            notRelative: this.taxReviewControls['notRelative'].value == null ? false : this.taxReviewControls['notRelative'].value,
            notE2: this.taxReviewControls['notE2'].value == null ? false : this.taxReviewControls['notE2'].value,
            isIndividual: this.taxReviewControls['isIndividual'].value == null ? false : this.taxReviewControls['isIndividual'].value,
            iscooperation: this.taxReviewControls['iscooperation'].value == null ? false : this.taxReviewControls['iscooperation'].value,
            ispartnerships: this.taxReviewControls['ispartnerships'].value == null ? false : this.taxReviewControls['ispartnerships'].value,
            istrust: this.taxReviewControls['istrust'].value == null ? false : this.taxReviewControls['istrust'].value,
            declaration: this.taxReviewControls['declaration'].value == null ? false : this.taxReviewControls['declaration'].value,
            certification: this.taxReviewControls['certification'].value == null ? false : this.taxReviewControls['certification'].value,
            taxDeclarationCompleted: this.taxReviewControls['taxDeclarationCompleted'].value == null ? false : this.taxReviewControls['taxDeclarationCompleted'].value,
            noChangeofOwnership: this.taxReviewControls['noChangeofOwnership'].value == null ? false : this.taxReviewControls['noChangeofOwnership'].value,
            beneficialOwnerCertification: this.taxReviewControls['beneficialOwnerCertification'].value == null ? false : this.taxReviewControls['beneficialOwnerCertification'].value,
            hasAgree: this.taxReviewControls['hasAgree'].value == null ? false : this.taxReviewControls['hasAgree'].value,
            agreeMetadata: this.taxReviewControls['agreeMetadata'].value == null ? false : this.taxReviewControls['agreeMetadata'].value,

            tempCertificationId: AppSettings.getCertificationID(),
            participantId: AppSettings.getParticipantID(),
            refCode: AppSettings.getReferenceCode(),
            countryOfResidence: this.identity.residencyCountry,
            shareholderType: this.identity.typeId,
            shareWorthLess300k: this.shareWorthLess300k,
            shareWorthMore500k: this.shareWorthMore500k
        }

        this.certificationService.submitTaxReview(taxReviewModel)
            .subscribe((response: any) => {
                if (response.valid > 0) {
                    ////show success message..
                    ////Save the TempCert ID in localstorage and move to Review Page....
                    sessionStorage.setItem("refNo", response.referenceNo);
                    this.router.navigate(['complete/']);
                }
            }
                ,
                (error) => {
                    this.errorCollection = error;
                }
            );
    }

    clearUIErrors() {
        this.errorCollection = [];
    }

    confirmYes() {
        AppSettings.removereferenceNumber();
        AppSettings.removeTempCertificationId();
        this.router.navigate(['welcome/']);
    }

    onBackClick() {

        var w8files = this.fileAttachments.filter(dc => (dc.type.toLowerCase() == 'w9-online' || dc.type.toLowerCase() == 'w8-online'));

        if (w8files.length > 0) {

            this.certificationService.removeTempAttachment({ identifier: w8files[0].fileId }).subscribe();

            this.certificationService.getW8W9BackUrl({ identifier: AppSettings.getCertificationID() }).subscribe((response: any) => {
                window.location.href = response.websiteBackUrl;
            });

           
        }
        else
            this.router.navigate(['form/']);
    }

    downloadFile(fileId: string, fileName: string) {
        this.certificationService.downloadAttachment(fileId, fileName);
    }

    /* Modal Dialogs --------------------------------------------------------------------------------------------------------------- */

    // The Dialog shows within the target element.
    public targetElement: HTMLElement;

    // Sets the Dialog to hidden on page load
    public visible: Boolean = false;

    @ViewChild('cancelConfirmationDialog', { static: false }) public cancelConfirmationDialog: DialogComponent;

    // Call the show method to open the Dialog
    public showCancelConfirmationDialog = function (event: any): void {
        this.cancelConfirmationDialog.show();
    }

    // Hide the Dialog when click the footer button.
    public hideCancelConfirmationDialog: EmitType<object> = () => {
        this.cancelConfirmationDialog.hide();
    }

}
